export default "__VITE_ASSET__DctUe0H9__"